<template>
  <section id="print-labels" v-if="labels.length">
    <div class="label" v-for="(label, index) in labels" :key="index">
      <span class="label-name"
        ><b>نام گیرنده : {{ label.fullName }}</b></span
      >
      <span class="label-address"><b>آدرس :</b> {{ label.addressString }}</span>
      <span class="label-postal-code"
        ><b>کد پستی :</b> {{ label.postalCode }}</span
      >
      <span class="label-phone"><b>تلفن :</b> {{ label.mobile }}</span>
      <span class="label-order-type">{{ label.desginTypeTitle }}</span>
      <span class="label-order-id">{{ label.orderId }}</span>
      <barcode
        v-if="label.postTrackingCode"
        v-bind:value="label.postTrackingCode"
        :text-margin="'-6'"
        height="34px"
        width="2"
      ></barcode>
    </div>
  </section>
  <section id="print-labels" v-else>
    <p
      style="text-align: center;direction: rtl;font-family: 'IRANSansWebFaNum'"
    >
      لطفا صبر کنید ...
    </p>
  </section>
</template>

<script>
import VueBarcode from "vue-barcode";
export default {
  name: "Label",
  data() {
    return {
      labels: [],
    };
  },
  components: {
    barcode: VueBarcode,
  },
  methods: {
    getData() {
      const filters = localStorage.getItem("filter")
        ? JSON.parse(localStorage.getItem("filter"))
        : {};
      localStorage.removeItem("filter");
      this.$api.post("CardIssue/Cards/Search", filters).then(({ data }) => {
        if (data.status) {
          this.labels = data.result.list;
          setTimeout(() => {
            window.print();
          }, 500);
        }
      });
    },
  },
  created() {
    this.getData();
    document.head.innerHTML = `
        <title>چاپ لیبل سفارشات</title>
        <style>
            body{
                margin: 0;
                padding: 0;
                background: #fff;
            }
            .label{
                direction: rtl;
                text-align: right;
                font-family: 'IRANSansWebFaNum';
                position: relative;
                width: 95mm;
                height: 47mm;
                margin-top: 2mm;
                border: 3px solid #fff;
                margin-bottom: 30px;
                padding: 7px;
                box-sizing: border-box;
                margin-bottom: 48mm;
                margin-left: 3mm;
                font-size: 11px
            }
            .label-name{
                font-size: 13px
            }
            .label span{
                display: block;
                width: 100%;
            }
            .label svg{
                position: absolute;
                bottom: 0;
                right: 0;
                width: 100%
            }
            .label svg text{
                font-size: 16px !important;
                transform: translateX(-18px);
            }
            .label svg > rect{
                fill: transparent !important;
            }
            .label svg g{
                transform: translate(26px,10px)
            }
            .label svg g > rect{
                transform: scale(0.9);
            }
            .label-order-type{
                position: absolute;
                left: 10px;
                width: 120px !important;
                border: 2px solid #000;
                text-align: center;
                height: 25px;
                line-height: 25px;
                bottom: 65px;
            }
            .label-order-id{
                position: absolute;
                left: 140px;
                width: 80px !important;
                border: 2px solid #000;
                text-align: center;
                height: 25px;
                line-height: 25px;
                bottom: 65px;
            }
            @media print{
                .back-btn{
                    display: none
                }
                div{
                    break-inside: avoid;
                }
                div.label{
                    display: table
                }
                div{
                    page-break-inside: avoid
                }
            }
        </style>`;
  },
};
</script>
